import * as React from 'react';

import { renderComp } from '@components/utils';

import { ConsentFormPage, Props } from './ConsentFormPage';

export function mount(): void {
  renderComp<Props>('consent-form-page', (props) => <ConsentFormPage {...props} />);
}
